import { ViewItemListTracker, CtrImpressionsTracker } from 'Pods/Shared/UserTracker/UserTracker'

window.addEventListener("load", () => {
  ViewItemListTracker()
  CtrImpressionsTracker()

  const ReactRailsUJS = require("react_ujs");
  const context = require.context('Pods', true, /\/CollectionHub\/(?!.*(?:test|story).*$).*$/)

  ReactRailsUJS.useContext(context);
  ReactRailsUJS.mountComponents("#collection-hub-elements");
});
